import { render } from "./AICourseCreate.vue?vue&type=template&id=b1b3f3a2&scoped=true"
import script from "./AICourseCreate.vue?vue&type=script&lang=js"
export * from "./AICourseCreate.vue?vue&type=script&lang=js"

import "./AICourseCreate.vue?vue&type=style&index=0&id=b1b3f3a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b3f3a2"]])

export default __exports__